export var validators = {
    between: function (value, min, max) {
        return value >= min && value <= max
            ? undefined
            : "Value should be between " + min + " and " + max;
    },
    min: function (value, min) {
        return value >= min ? undefined : "Value should be at least " + min;
    },
    required: function (value) { return (!value ? "Required" : undefined); }
};
